import { createContext, useContext } from 'react'

export const SharedDashboardContext = createContext<string | null>(null)

export const useSharedDashboardId = () => useContext(SharedDashboardContext)
